import { useState } from 'react';

const faqs = [
  {
    id: 1,
    question: '¿Es LELO seguro para el cuerpo?',
    answer: 'Sí, absolutamente. Todos los productos LELO están fabricados con silicona de grado médico, libre de ftalatos y completamente aprobados para uso íntimo. Son hipoalergénicos y seguros para todo tipo de pieles.',
    icon: 'ri-shield-check-line'
  },
  {
    id: 2,
    question: '¿Cuánto duran las baterías?',
    answer: 'Los productos LELO ofrecen entre 1 y 2 horas de uso continuo con una carga completa. Se recargan mediante USB y la carga completa tarda aproximadamente 2 horas. Una sola carga puede durar varias sesiones.',
    icon: 'ri-battery-charge-line'
  },
  {
    id: 3,
    question: '¿Son productos silenciosos?',
    answer: 'Sí, LELO está diseñado para privacidad total. Todos los modelos son extremadamente silenciosos, incluso en los niveles de vibración más altos. Puedes usarlos con total discreción.',
    icon: 'ri-volume-mute-line'
  },
  {
    id: 4,
    question: '¿Puedo usarlos en el agua?',
    answer: 'Sí, todos los modelos presentados son 100% resistentes al agua (IPX7). Puedes usarlos en la ducha, bañera o jacuzzi sin ningún problema. Además, esto facilita mucho su limpieza.',
    icon: 'ri-drop-line'
  }
];

export default function FAQ() {
  const [openId, setOpenId] = useState<number | null>(1);

  const toggleFAQ = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section id="faq" className="py-16 sm:py-20 px-4 sm:px-6 bg-gradient-to-b from-pink-50/30 to-white">
      <div className="max-w-4xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-flex items-center gap-2 bg-fuchsia-100 text-fuchsia-700 px-4 sm:px-6 py-2 rounded-full text-xs sm:text-sm font-semibold mb-4 sm:mb-6">
            <i className="ri-question-answer-line"></i>
            <span>Preguntas frecuentes</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 px-2">
            Resolvemos tus dudas
          </h2>
          <p className="text-base sm:text-lg text-gray-600 px-2">
            Todo lo que necesitas saber sobre LELO
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-4">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className="bg-white rounded-xl sm:rounded-2xl border border-gray-200 hover:border-fuchsia-300 transition-all duration-300 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(faq.id)}
                className="w-full flex items-center justify-between gap-3 sm:gap-4 p-4 sm:p-6 text-left cursor-pointer hover:bg-pink-50/30 transition-colors"
              >
                <div className="flex items-center gap-3 sm:gap-4 flex-1 min-w-0">
                  <div className={`w-10 h-10 sm:w-12 sm:h-12 flex-shrink-0 rounded-lg sm:rounded-xl flex items-center justify-center ${
                    openId === faq.id 
                      ? 'bg-gradient-to-br from-fuchsia-500 to-pink-500' 
                      : 'bg-gray-100'
                  } transition-all duration-300`}>
                    <i className={`${faq.icon} text-xl sm:text-2xl ${
                      openId === faq.id ? 'text-white' : 'text-gray-600'
                    }`}></i>
                  </div>
                  <h3 className="text-sm sm:text-base md:text-lg font-bold text-gray-900 break-words">{faq.question}</h3>
                </div>
                <i className={`ri-arrow-down-s-line text-xl sm:text-2xl text-gray-600 transition-transform duration-300 flex-shrink-0 ${
                  openId === faq.id ? 'rotate-180' : ''
                }`}></i>
              </button>

              {/* Answer */}
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openId === faq.id ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-4 sm:px-6 pb-4 sm:pb-6 pt-2">
                  <div className="pl-0 sm:pl-16">
                    <p className="text-sm sm:text-base text-gray-700 leading-relaxed">{faq.answer}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Contact Box */}
        <div className="mt-10 sm:mt-12 bg-gradient-to-r from-pink-50 to-fuchsia-50 rounded-xl sm:rounded-2xl p-6 sm:p-8 text-center border border-pink-200/50">
          <i className="ri-customer-service-2-line text-4xl sm:text-5xl text-fuchsia-500 mb-4"></i>
          <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 px-2">¿Necesitas más ayuda?</h3>
          <p className="text-sm sm:text-base text-gray-700 mb-6 px-2">
            Nuestro equipo está disponible para resolver cualquier duda adicional
          </p>
          <a
            href="#contacto"
            className="whitespace-nowrap inline-flex items-center gap-2 bg-gradient-to-r from-fuchsia-500 to-pink-500 hover:from-fuchsia-600 hover:to-pink-600 text-white px-6 sm:px-8 py-3 rounded-full text-sm sm:text-base font-semibold transition-all duration-300 cursor-pointer"
          >
            <span>Contactar</span>
            <i className="ri-mail-line text-lg sm:text-xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
